var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68421 6.55C5.68421 5.14167 6.81528 4 8.21053 4H17.4737C18.8689 4 20 5.14167 20 6.55V14.9399C20 15.6215 19.7297 16.2746 19.2495 16.7537L15.7306 20.2638C15.2577 20.7355 14.6197 21 13.9548 21H8.21053C6.81528 21 5.68421 19.8583 5.68421 18.45H4.84211C4.37702 18.45 4 18.0694 4 17.6C4 17.1306 4.37702 16.75 4.84211 16.75H5.68421V13.35H4.84211C4.37702 13.35 4 12.9694 4 12.5C4 12.0306 4.37702 11.65 4.84211 11.65H5.68421V8.25H4.84211C4.37702 8.25 4 7.86944 4 7.4C4 6.93056 4.37702 6.55 4.84211 6.55H5.68421ZM8.21053 19.3C7.74544 19.3 7.36842 18.9194 7.36842 18.45H8.21053C8.67561 18.45 9.05263 18.0694 9.05263 17.6C9.05263 17.1306 8.67561 16.75 8.21053 16.75H7.36842V13.35H8.21053C8.67561 13.35 9.05263 12.9694 9.05263 12.5C9.05263 12.0306 8.67561 11.65 8.21053 11.65H7.36842V8.25H8.21053C8.67561 8.25 9.05263 7.86944 9.05263 7.4C9.05263 6.93056 8.67561 6.55 8.21053 6.55H7.36842C7.36842 6.08056 7.74544 5.7 8.21053 5.7H17.4737C17.9388 5.7 18.3158 6.08056 18.3158 6.55V13.35H15.7895C13.9291 13.35 12.4211 14.8722 12.4211 16.75V19.3H8.21053ZM14.1053 19.2863C14.2711 19.2559 14.4253 19.1758 14.5467 19.0546L18.0656 15.5445C18.1996 15.4109 18.2846 15.2365 18.3087 15.05H15.7895C14.8593 15.05 14.1053 15.8111 14.1053 16.75V19.2863Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotice);
export default __webpack_public_path__ + "static/media/icon_notice.1a4fa400b04ed3cb923eed7712e6cc72.svg";
export { ForwardRef as ReactComponent };